/* React */
import React from "react";

/* Ionic */
import { IonIcon, IonSegmentButton } from "@ionic/react";
import { ellipseOutline, radioButtonOnOutline } from "ionicons/icons";

/* Stylesheet */
import styles from "./SegmentButton.module.scss";

/* Interface(s) */
interface SegmentButtonProps {
  scssProps?: ScssProps;
  label: any;
  value: boolean;
  icon?: string;
  disabled?: boolean;
  onClick: () => void;
}

interface ScssProps {
  width?: string;
}

const SegmentButton: React.FC<SegmentButtonProps> = ({
  scssProps,
  label,
  value,
  icon,
  disabled,
  onClick,
}) => {
  return (
    <IonSegmentButton
      style={{
        width: scssProps?.width,
        color: value
          ? "var(--ion-color-primary)"
          : "var(--ion-color-text-primary)",
        background: "var(--ion-gradient-light)",
        "--color-hover": value
          ? "var(--ion-color-primary)"
          : "var(--ion-color-text-primary)",
      }}
      className={styles.segment_button}
      disabled={disabled}
      onClick={onClick}
    >
      <div className={styles.wrapper_container}>
        {icon ? (
          <IonIcon className={styles.icon} icon={icon} slot="start" />
        ) : (
          <IonIcon
            style={{
              color: value
                ? "var(--ion-color-primary)"
                : "var(--ion-color-text-tertiary)",
            }}
            className={styles.icon}
            icon={value ? radioButtonOnOutline : ellipseOutline}
          />
        )}
        <div className={styles.label}>{String(label)}</div>
      </div>
    </IonSegmentButton>
  );
};

export default SegmentButton;
